export default __webpack_public_path__ + "static/media/thouthbwgaismall.ca24b26e.png";